<template>
    <!-- Panel content -->
    <div class="panel__content">
        <v-form>
            
            <v-row justify="space-between" no-gutters class="mb-5">
                
                <!-- <v-col>
                    <DashNotificationContent1 v-if="appStore.User.DashNotificationId == 1" />
                    <DashNotificationContent2 v-else-if="appStore.User.DashNotificationId == 2" />
                    <DashNotificationContent3 v-else-if="appStore.User.DashNotificationId == 3" />
                </v-col> -->
                <v-col>
                    <component :is="currentNotificationComponent" />
                </v-col>
                
            </v-row>
           
            <v-row justify="space-between" no-gutters>
                
                <!-- Prilaganje datotek -->
                <v-col>
                    <div class="mb-2">
                        <v-checkbox
                            v-model="appStore.User.IsIdentificationSuccessful"
                            :error-messages="v$.IsIdentificationSuccessful.$errors[0] != null ? v$.IsIdentificationSuccessful.$errors[0].$message : ''"
                            @focus="v$.IsIdentificationSuccessful.$reset"  
                            label="Potrjujem, da sem seznanjem z navedenimi informacijami."
                        ></v-checkbox>
                    </div>
                </v-col>
                
            </v-row>
            
        </v-form>
    </div>
                    
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { useVuelidate } from "@vuelidate/core";
    import { useAppStore } from "@/app/store/app/store";
    import { i18n } from "@app/i18n";
	import { helpers, sameAs } from "@vuelidate/validators";
    import DashNotificationContent1 from "./dash-notification-content-1.vue";
    import DashNotificationContent2 from "./dash-notification-content-2.vue";
    import DashNotificationContent3 from "./dash-notification-content-3.vue";

    const appStore = useAppStore();

    const emit = defineEmits(['isFormValid']);

    const notificationComponents = {
        1: DashNotificationContent1,
        2: DashNotificationContent2,
        3: DashNotificationContent3,
    };

    const currentNotificationComponent = computed(() => {
        return notificationComponents[appStore.User.DashNotificationId as keyof typeof notificationComponents] || null;
    });

    const validationRules = computed(() => ({
        IsIdentificationSuccessful: {
            required: helpers.withMessage(i18n.global.t("Potrditev je pogoj za nadaljevanje"), sameAs(true)),
        }
    }))

    const v$: any = useVuelidate(validationRules, appStore.User, {$autoDirty: true});
</script>